import { is } from '../util/is';

/**
 * Takes a value and returns a shallow clone of that value.
 *
 * ```ts
 * const a = { x: 1 };
 * const b = tt.clone(a);
 * // => { x: 1 }
 * // a !== b
 * ```
 *
 * @param a The value to clone.
 */
export function clone<A>(a: A): A {
  if (is(Array, a)) {
    return Object.assign([], a);
  } else if (is(Object, a)) {
    return Object.assign({}, a);
  } else {
    return a;
  }
}
